import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { GeneralService } from 'src/app/services/general.service';
import { PaymentService } from 'src/app/services/payment.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-payment-info',
  templateUrl: './payment-info.component.html',
  styleUrls: ['./payment-info.component.css']
})
export class PaymentInfoComponent implements OnInit {

  @Input() vista_externa: boolean = false;
  @Input() beneficiario_externo: any = false;

  usuario: any = {};

  _title = 'Mi agenda';
  _subtitle = 'Reserva tu hora';
  subtitle = 'Reserva';

  // showSuccessMessage = true; 
  steps: any = {
    searchDoctor: false,
    selectDate: false,
    completeForm: false,
    payment: false,
    showSummary: true
  }
  msg_status = '';
  sub_msg_status = '';

  infoTransaction: any = null;

  // flags para template (evita repetir lógica en el HTML)
  isPaidOk: boolean = false;

  constructor(
    public generalService: GeneralService,
    private activatedRoute: ActivatedRoute,
    private paymentService: PaymentService,
    private router: Router,
  ) {
    this.activatedRoute.params.subscribe(parametros => {
      if (parametros.idTransaction) {
        this.postInfoTransaction(parametros.idTransaction, parametros.tipoPago);
      }
    });
  }

  ngOnInit(): void {
    if (!this.vista_externa) {
      this.usuario = new EncriptacionService().getUserInfo();
    } else {
      this.usuario = this.beneficiario_externo;
    }
  }

  private computePaidOk(data: any): boolean {
    // TBK: viene en tra_metadata.status = 'AUTHORIZED'
    const tbkOk = data?.tra_metadata?.status === 'AUTHORIZED';
    // Snabb: viene en status = 'Payed'
    const snabbOk = data?.status === 'Payed';
    return tbkOk || snabbOk;
  }

  private setMessages(isOk: boolean): void {
    if (isOk) {
      this.msg_status = '¡Tu pago se ha realizado con éxito!';
      this.sub_msg_status = 'Ya puedes acceder a nuestra fila virtual. Estamos buscando un medico para que te atienda lo antes posible.';
    } else {
      this.msg_status = '¡Hemos tenido inconvenientes para realizar tu pago!';
      this.sub_msg_status = 'Intenta nuevamente más tarde o selecciona otro medio de pago.';
    }
  }

  async postInfoTransaction(buyOrder: any, tipoPago: any) {
    this.generalService.modalCargando();

    await this.paymentService.infoTransaction(buyOrder, tipoPago)
      .then((result: any) => {

        Swal.close();
        // console.log('infoTransaction result:', result);

        // guardamos data
        this.infoTransaction = result;
// console.log(this.infoTransaction);

        // Redirecciones especiales por estado booking
        if (result?.boo_sta_id == 90 && result?.id_consulta) {
          const url = `reserva-pendiente/${result.id_consulta}/${this.infoTransaction.tra_metadata.status}`;
          this.router.navigate([url]);
          return;
        }

        if (result?.boo_sta_id == 11 && result?.id_consulta) {
          this.generalService.modalError('Error en pago', 'Hubo un error en el pago de la consulta, intentelo nuevamente.');
          this.router.navigate(['dashboard']);
          return;
        }

        // Calculamos si el pago fue OK (sirve tanto para tbk como snabb)
        this.isPaidOk = this.computePaidOk(this.infoTransaction);
        // console.log(this.isPaidOk);
        
        // Mensajes (solo tienen sentido para ondemand, pero los dejamos listos)
        this.setMessages(this.isPaidOk);

      })
      .catch(error => {
        console.log(error, 'error-infoTransaction');
        Swal.close();
        this.generalService.modalError('Error en pago', 'Hubo un error en el pago de la consulta, intentelo nuevamente.');
        this.router.navigate(['dashboard']);
      });
  }

}
